"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS = exports.HOURS = exports.MINUTES = exports.SECONDS = void 0;
/* equivalent number of milliseconds */
exports.SECONDS = 1000;
exports.MINUTES = 60000;
exports.HOURS = 3600000;
exports.DAYS = 86400000;
